import api from '../api';

export const login = (credentials) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });
  api
    .login(credentials)
    .then((res) => {
      dispatch({
        type: 'LOGIN_SUCCESS',
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: 'AUTH_ERROR',
        payload: err.response.data,
      });
    })
    .finally(() => {
      dispatch({
        type: 'IS_NOT_LOADING',
      });
    });
};

export const forgotPassword = (email) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });
  api
    .forgotPassword(email)
    .then((res) => {
      dispatch({
        type: 'FORGOT_PASSWORD_SUCCESS',
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: 'AUTH_ERROR',
        payload: err.response.data,
      });
    })
    .finally(() => {
      dispatch({
        type: 'IS_NOT_LOADING',
      });
    });
};

export const resetPassword = (data) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });
  api
    .resetPassword(data)
    .then((res) => {
      dispatch({
        type: 'RESET_PASSWORD_SUCCESS',
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err.response);
      dispatch({
        type: 'AUTH_ERROR',
        payload: err.response.data,
      });
    })
    .finally(() => {
      dispatch({
        type: 'IS_NOT_LOADING',
      });
    });
};

export const changePassword = (data) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });
  api
    .changePassword(data)
    .then((res) => {
      dispatch({
        type: 'RESET_PASSWORD_SUCCESS',
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err.response);
      dispatch({
        type: 'AUTH_ERROR',
        payload: err.response.data,
      });
    })
    .finally(() => {
      dispatch({
        type: 'IS_NOT_LOADING',
      });
    });
};

export const validateToken = (token) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });
  api
    .validateToken({ token })
    .then((res) => {
      dispatch({
        type: 'TOKEN_VALID',
      });
    })
    .catch((err) => {
      dispatch({
        type: 'TOKEN_INVALID',
        payload: err.response.data.error,
      });
    })
    .finally(() => {
      dispatch({
        type: 'IS_NOT_LOADING',
      });
    });
};

export const logout = () => (dispatch) => {
  api
    .logout()
    .then(() => {
      dispatch({
        type: 'LOGOUT',
      });
    })
    .catch((err) => {
      dispatch({
        type: 'LOGOUT_FAILURE',
      });
    });
};

export const initialise = () => (dispatch) => {
  dispatch({
    type: 'VALIDATING_AUTH_TOKEN',
    payload: true,
  });
  validateAuthToken()(dispatch).finally(() => {
    dispatch({
      type: 'VALIDATING_AUTH_TOKEN',
      payload: false,
    });
  });
};

export const validateAuthToken = () => (dispatch) => {
  return api
    .authenticateWithToken()
    .then((res) => {
      dispatch({
        type: 'LOGIN_SUCCESS',
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: 'LOGOUT',
      });
    });
};
